<p-card class="text-start choose-option-card" header="">
  <div class="row">
    <div class="col-sm-12 mt-3">
      <div class="mb-3 d-md-flex justify-content-between">
        <label class="col-form-label d-block font-20 mb-2 fw-bold"
          >Choose Your Excess
            <span class="d-inline-block ttbg lightcbg cancellation" *ngIf="selectedCover?.selectedCoverTitle != 'Rental Car Excess'" tabindex="0">
              <ng-container *ngIf="isTooltipVisibleExcess; else toolTipOnHover">
                <div (click)="toggleTooltip()" class="tooltip-container">
                  <img
                    src="assets/icons/w2c/tooltipinfo.png"
                    class="tooltipc cancellation-tooltip"
                    width="20"
                  />
                  <ng-container *ngIf="isTooltipVisibleExcess">
                    <ng-container *ngTemplateOutlet="excessfTooltip"></ng-container>
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #toolTipOnHover>
                <img
                  src="assets/icons/w2c/tooltipinfo.png"
                  class="tooltipc"
                  width="20"
                  [pTooltip]="excessTooltip"
                  tooltipPosition="right"
                  tooltipStyleClass="cancellation-tooltip"
                />
              </ng-template>
            </span>
        </label>
        <div>
          <button
            *ngFor="let excess of selectedCover.excessValues"
            type="button"
            class="btn szbtn btn-lg btn-outline-info px-4 moboptbtn mb-1"
            [ngClass]="{ 'selected-label': selectedExcessLabel === excess }"
            pButton
            (click)="onRadioExcessClick($event, excess)"
          >
            {{ excess }}
          </button>

         
        </div>
      </div>
    </div>
  </div>
  <div class="additional-option d-none">
    ~ If you change the Cover Type selected, you will need to re-select your
    Options
  </div>
</p-card>
<ng-template #excessTooltip>
  <div
    [ngClass]="
      isTooltipVisibleExcess
        ? { 'tooltip-content tooltip-excess': true, show: true }
        : ''
    "
  >
     An excess is an agreed dollar amount that is subtracted from each and every
    Insured Event - see the definitions of 'Excess' and 'Insured Event' in the
    PDS for more information. Your excess will be shown on your certificate of
    insurance. Please note if you choose a higher excess it can reduce your
    premiums but it will affect the benefit you receive when you make a claim.
    Some cover benefit limits or sub-limits may be less than your total excess
    and therefore the insurer may not contribute anything to your claim.
 
  </div>
</ng-template>

<ng-template #excessfTooltip>
  <div
    [ngClass]="
      isTooltipVisibleExcess
        ? { 'tooltip-content tooltip-excessf': true, show: true }
        : ''
    "
  >
     An excess is an agreed dollar amount that is subtracted from each and every
    Insured Event - see the definitions of 'Excess' and 'Insured Event' in the
    PDS for more information. Your excess will be shown on your certificate of
    insurance. Please note if you choose a higher excess it can reduce your
    premiums but it will affect the benefit you receive when you make a claim.
    Some cover benefit limits or sub-limits may be less than your total excess
    and therefore the insurer may not contribute anything to your claim.
  </div>
</ng-template>
